<template>
  <div>
    <div class="mb-2">
      <va-input
        :value="searchQuery"
        placeholder="Поиск товаров для добавления..."
        clearable
        @input="onSearchInput"
      />
    </div>

    <div
      v-if="searchResults.length > 0"
      class="bundle-products-search-results mb-2"
    >
      <div
        v-for="product in searchResults"
        :key="product.id"
        class="bundle-products-search-item"
      >
        <span>{{ product.name }}</span>
        <va-button
          size="small"
          :disabled="isProductAdded(product.id)"
          @click="$emit('add-product', product)"
        >
          {{ isProductAdded(product.id) ? "Добавлен" : "Добавить" }}
        </va-button>
      </div>
    </div>

    <div v-if="rows.length" class="components-table mt-3">
      <div class="components-table__head">
        <div class="components-table__cell">Товар</div>
        <div class="components-table__cell">Цена</div>
        <div class="components-table__cell">Кол-во</div>
        <div class="components-table__cell">Скидка %</div>
        <div class="components-table__cell"></div>
      </div>
      <div class="components-table__body">
        <div
          v-for="(row, idx) in rows"
          :key="row.product.id"
          class="components-table__row"
        >
          <div class="components-table__cell">{{ row.product.name }}</div>
          <div class="components-table__cell">
            {{ row.product.price_current ?? row.product.price?.current }} ₽
          </div>
          <div class="components-table__cell">
            <input v-model.number="row.quantity" type="number" min="1" />
          </div>
          <div class="components-table__cell">
            <input
              v-model.number="row.discount_percent"
              type="number"
              min="0"
              max="100"
              step="0.1"
            />
          </div>
          <div class="components-table__cell">
            <va-button
              flat
              small
              color="gray"
              icon="fa fa-trash"
              @click="$emit('remove-row', idx)"
            />
          </div>
        </div>
      </div>
    </div>

    <div v-if="rows.length === 0" class="text-muted mt-2">
      Добавьте товары, из которых собирается комплект
    </div>
  </div>
</template>

<script>
export default {
  name: "BundleComponentsEditor",
  props: {
    searchQuery: {
      type: String,
      default: "",
    },
    searchResults: {
      type: Array,
      default: () => [],
    },
    rows: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    onSearchInput(value) {
      this.$emit("update:search-query", value);
      this.$emit("search-input", value);
    },
    isProductAdded(productId) {
      return this.rows.some((row) => row.product.id === productId);
    },
  },
};
</script>

<style scoped>
.components-table {
  width: 100%;
}

.components-table__head,
.components-table__row {
  display: grid;
  grid-template-columns: 1fr 100px 80px 80px 44px;
  gap: 8px;
  align-items: center;
}

.components-table__head {
  font-weight: 600;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 6px;
}

.components-table__row {
  border-bottom: 1px solid #e0e0e0;
  padding: 8px 0;
}

.components-table__cell {
  text-align: left;
}

.components-table__cell input {
  width: 100%;
}

.components-table__body {
  max-height: 500px;
  overflow-y: auto;
}

.bundle-products-search-results {
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 4px;
}

.bundle-products-search-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 10px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.bundle-products-search-item:last-child {
  border-bottom: none;
}
</style>
